export default "__VITE_ASSET__QvBH_0Na__"